import hasSelectedOtherColors from './has-selected-other-colors';

/**
 * Checks if the filter checkbox should be checked.
 *
 * @param categoryName Category name of the filter
 * @param filter Filter value
 * @param selectedFilters Currently selected filters
 * @returns True if the filter should be checked, false if not.
 */
export default function isFilterCheckboxChecked(
  categoryName: string,
  filter: string,
  selectedFilters?: string[]
) {
  return (
    selectedFilters !== undefined &&
    (selectedFilters.includes(filter) ||
      hasSelectedOtherColors(categoryName, filter, selectedFilters))
  );
}
